export var BreakpointsEnum;
(function (BreakpointsEnum) {
    BreakpointsEnum[BreakpointsEnum["GRID_MOBILE"] = 360] = "GRID_MOBILE";
    BreakpointsEnum[BreakpointsEnum["MOBILE"] = 768] = "MOBILE";
    BreakpointsEnum[BreakpointsEnum["TABLET"] = 1024] = "TABLET";
    BreakpointsEnum[BreakpointsEnum["GRID_DESKTOP"] = 1024] = "GRID_DESKTOP";
    BreakpointsEnum[BreakpointsEnum["DESKTOP"] = 1920] = "DESKTOP";
    BreakpointsEnum[BreakpointsEnum["WIDE_DESKTOP"] = 2560] = "WIDE_DESKTOP";
    BreakpointsEnum[BreakpointsEnum["ULTRA_WIDE_DESKTOP"] = 3440] = "ULTRA_WIDE_DESKTOP";
})(BreakpointsEnum || (BreakpointsEnum = {}));
//# sourceMappingURL=breakpoints.enum.js.map